module.exports = __webpack_public_path__ + "assets/e1e8731a1870926b9e5e063d86906e38.png";